import _ from 'lodash';
import * as requests from '../request';

import { constructIdentifier, regexCustomValidations, getDependsOnModel } from '../functions';
import { dependsOnModelRegex } from '../constants';

/**
 * Hook that returns request function based on its name and given params
 * @param {String} dependsOn show_on values from json form schema
 * @param {String} onChange function name
 * @param {String} params root parameters created with constructDependsOnParams function
 * @param {String} val value for big family card
 * @param {[Object, null]} searchParams search params from URL
 * @returns {[Function, null]} react-fetching-library request function or null if not enought data
 */
export default (dependsOn, onChange, params, val, searchParams = null) => {
  if (_.isNil(onChange)) {
    return null;
  }
  if (!_.isNil(dependsOn)) {
    const dependsOnModel = getDependsOnModel(dependsOn.replace('\n', '').split(' '));
    if (!_.isEmpty(dependsOnModel) && regexCustomValidations(dependsOnModel[0], dependsOnModelRegex) && !_.isNil(onChange)) {
      return requests[onChange](constructIdentifier(dependsOn), params, searchParams);
    }
    try {
      return requests[onChange](params);
    } catch (err) {
      return null;
    }

  } else if (!_.isNil(onChange)) {
    if (onChange.includes('Function')) {
      return null;
    }

    return requests[onChange](val);
  }

  return null;
};
